import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../config/service";

export const statesApiService = createApi({
   reducerPath: "statesApiService",
   baseQuery: axiosBaseQuery(),
   endpoints: (builder) => ({
      fetchStates: builder.query({
         query: () => ({
            url: "/api/property/static/states/index.json",
            method: "GET",
            // headers:headers
         }),
         providesTags: ["fetchStates"],

      }),
      fetchAgricultureDocuments: builder.query({
         query: (stateName) => ({
            url: `/api/property/static/states/${stateName}/agriculture/index.json`,
            method: 'GET'
         }),
         providesTags: ["fetchAgricultureDocuments"],
      }),
      fetchNonAgricultureDocuments: builder.query({
         query: (stateName) => ({
            url: `/api/property/static/states/${stateName}/non-agriculture/index.json`,
            method: 'GET'
         }),
         providesTags: ["fetchNonAgricultureDocuments"],
      })

   }),
});

export const { useFetchStatesQuery, useFetchAgricultureDocumentsQuery, useFetchNonAgricultureDocumentsQuery } = statesApiService;